module.exports = __webpack_public_path__ + "static/img/alpha.6a7aba1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/main/assets/alpha.png
// module id = 1827
// module chunks = 9